module.exports = __webpack_public_path__ + "static/media/date.1082d7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/date.png
// module id = 31
// module chunks = 0